import React from 'react';
import { EditModifierRestaurantPropertiesState } from './editModifierRestaurantPropertiesState/EditModifierRestaurantPropertiesState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

export const EditModifierRestaurantPropertiesPage: React.FC = () => {
	return (
		<EditModifierRestaurantPropertiesState>
			<Forms />
			<ModalWindows />
		</EditModifierRestaurantPropertiesState>
	);
};
